import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useStore } from "../../context/state";
import { useRouter } from "../../hooks/useRouter";
import Link from "next/link";
import "./style.styl";

export default function BlogCategoryMenu(props) {
    const {items, selected} = props;
    const {isMobile, dispatch} = useStore();

    return (
        <Tabs value={selected} onChange={() => null} className="blog-tabs u-relative">

            <Tab label={
                <Link href={"/blog"}>
                    <a>
                        <div className = "u-flexCenter">Home</div>
                    </a>
                </Link>
                }
                value={"main"}/>
            {
                items.map((item, i) => {
                    return (
                                <Tab label={
                                        <Link href={"/blog/category/" + item.slug}>
                                            <a>
                                                <div className = "u-flexCenter">{item.name}</div>
                                            </a>
                                        </Link>
                                    }
                                    value={item.slug}/>
                    );
                })
            }
        </Tabs>
    );
}
